import BaseSVG, { BaseSVGProps } from '../BaseSVG'

export const ChevronLeftIcon = (props: BaseSVGProps) => {
  return (
    <BaseSVG {...props} viewBox="0 0 16 16" fill="none">
      <path d="M10 12L6 8L10 4" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
    </BaseSVG>
  )
}
